/**
 * Building component - marks an entity as a building
 */

import type { BuildingType } from '@/types';

export const MAX_BUILDING_LEVEL = 3;

export interface BuildingComponent {
  buildingType: BuildingType;
  isConstructed: boolean;
  constructionProgress: number;
  level: number; // 1-3, affects efficiency
}

/**
 * Get efficiency multiplier for building level
 * Lv.1 = 1.0, Lv.2 = 1.3, Lv.3 = 1.6
 */
export function getBuildingEfficiency(level: number): number {
  switch (level) {
    case 1: return 1.0;
    case 2: return 1.3;
    case 3: return 1.6;
    default: return 1.0;
  }
}

/**
 * Get upgrade cost for a building (based on original cost)
 * Lv.1->2 = 50% of original, Lv.2->3 = 100% of original
 */
export function getUpgradeCost(baseCost: number, currentLevel: number): number {
  if (currentLevel >= MAX_BUILDING_LEVEL) return 0;
  return currentLevel === 1 ? Math.floor(baseCost * 0.5) : baseCost;
}

/**
 * Get repair cost based on damage taken
 * Cost = 1 gold per 10 HP to restore
 */
export function getRepairCost(damage: number): number {
  return Math.ceil(damage * 0.1);
}

export function createBuilding(buildingType: BuildingType, constructed: boolean = true): BuildingComponent {
  return {
    buildingType,
    isConstructed: constructed,
    constructionProgress: constructed ? 1 : 0,
    level: 1,
  };
}
